import './CameraTab.scss';
import { defineComponent } from 'vue';
import { Button, ModalBox, Selector } from '@/components/UI';
import { WebRTCPlayer } from '@/components/Widgets';
import useCameras from '@/compositions/useCameras';
import { CameraModus } from '@/types/cameras';
import { cloneDeep } from 'lodash';
import { useToast } from 'vue-toastification';
export default defineComponent({
    name: 'CameraTab',
    components: {
        WebRTCPlayer,
        Button,
        Selector,
        ModalBox
    },
    setup: () => ({
        ...useCameras(),
        toast: useToast()
    }),
    data: () => ({
        showCameraPopup: false,
        editCameras: {},
        editModus: {}
    }),
    computed: {
        selectedLarge() {
            return this.cameraIds.indexOf(this.selectedCameraId);
        },
        allCameraIds() {
            return Object.keys(this.cameras);
        },
        cameraIds() {
            return Object.keys(this.cameras);
        },
        largeCameraIds() {
            if (window.innerWidth < 1200) {
                return [];
            }
            return Object.keys(this.cameras);
        },
        modusOptions() {
            return [
                { value: CameraModus.Off, text: 'Off' },
                { value: CameraModus.Small, text: 'Small Only' },
                { value: CameraModus.Large, text: 'Large' }
            ];
        },
    },
    methods: {
        async update() {
            // console.log('Updating cameras', this.editCameras, this.editModus)
            const result = await this.updateCameras({ cameras: this.editCameras, modus: this.editModus });
            if (result) {
                this.toast.success('Updated cameras successfully');
            }
            else {
                this.toast.error('Could not update cameras');
            }
            this.showCameraPopup = false;
        },
        openPopup() {
            this.showCameraPopup = true;
            this.editCameras = cloneDeep(this.cameras);
            this.editModus = cloneDeep(this.camera_modus);
            const modi = ['all', 'public', 'active'];
            modi.forEach((id) => {
                if (this.editModus[id] === undefined) {
                    this.editModus[id] = {
                        cameras: {},
                        active_rooms: id === 'active'
                    };
                }
            });
        }
    }
});
